import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Markdown from 'markdown-to-jsx';
import axios from 'axios'

import { config } from "./config";

import './Study.css';

const BreakParagraph = ({ children, ...props }) => {
  return <p className="content-copy">{children}</p>
 };

const AbsoluteImage = ({ children, ...props }) => {
  const p = {...props, src: `studies/coromandel/${props.src}`}
  return <img {...p} />
 };

export class Study extends Component {

  constructor(props) {
    super(props);

    this.state = { fetched: false, content: "loading...", studyOffset: 0 }

    this.fetchStudyContent = this.fetchStudyContent.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchStudyContent(nextProps.currentStudy)
  }

  componentDidMount() {
    this.fetchStudyContent(this.props.currentStudy)
    window.addEventListener('scroll', this.positionStudy);
  }

  positionStudy = () => {
    if (this.props.presenting) {
      this.setState({
        studyOffset: 0,
      });
    } else {
      const scrollPos = window.pageYOffset
      const windowHeight = window.innerHeight
      const documentHeight = document.body.clientHeight
      if (documentHeight - windowHeight <= scrollPos)
      {
        this.setState({
          studyOffset: documentHeight - windowHeight,
        });
      } else
      {
        this.setState({
          studyOffset: scrollPos,
        });
      }
    }
  };

  fetchStudyContent(currentStudy) {
    if (currentStudy !== null) {
      axios
      .get("/studies/" + currentStudy.key + ".md")
      .then(res => {
        this.setState({ fetched: true, content: res.data })
      })
      .catch(error => {
        console.log(error)
      })
    }
  }

  render() {
    if (this.props.currentStudy === null) {
      return(<p>loading</p>)
    } else {
      var className = "cover-container"
      if (this.props.presenting === true) {
        className += " presented"
      }

      return (
        <Link className={className} style={{ top: this.state.studyOffset }} to={"/study/"+this.props.currentStudy.key+"?show=true"}>
          <div>
            { this.props.presenting && <Link className="about-link on-white" to={"/study/"+this.props.currentStudy.key}>Back to projects</Link> }
            <h1 className="content-title">{this.props.currentStudy.title}</h1>
            <div className="markdown-container">
              <Markdown options={{
                overrides: {
                  p: {
                    component: BreakParagraph
                  },
                  img: {
                    component: AbsoluteImage
                  }
                }
              }}
              children={this.state.content} />
             </div>
             { this.props.presenting && <Link className="about-link on-white" to={"/study/"+this.props.currentStudy.key}>Back to projects</Link> }
          </div>
        </Link>
      )
    }
  }
}